import { loyaltyConstants } from "./types";
import { addMember, getReferences } from "../../../services/loyalty.service";
import { alertActions, loading } from "../alert/actions";
import { beginLogout } from "../login/actions";

const endError = (error) => {
  return (dispatch) => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: loyaltyConstants.LOYALTY_ERROR,
        error,
      });
    }
  };
};

const addMembers = (name, surName, phone, text, kvkkIzni, kvkkMetni) => {
  return (dispatch) => {
    dispatch(request({ name }));
    return addMember(name, surName, phone, text, kvkkIzni, kvkkMetni).then(
      (loyalty) => {
        dispatch(success(loyalty));
      },
      (error) => {
        dispatch(endError(error));
      }
    );
  };
  function request(loyalty) {
    return { type: loyaltyConstants.ADD_MEMBER_REQUEST, payload: { loyalty } };
  }
  function success(loyalty) {
    return { type: loyaltyConstants.ADD_MEMBER_SUCCESS, payload: { loyalty } };
  }
};

const getReferenceList = () => {
  return (dispatch) => {
    dispatch(request());
    getReferences().then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: loyaltyConstants.REFERENCES_LIST_REQUEST,
      payload: {},
    };
  }
  function success(data) {
    return {
      type: loyaltyConstants.REFERENCES_LIST_SUCCESS,
      payload: { references: data },
    };
  }
};

const clearSuccessMessageLoyalty = () => {
  return {
    type: loyaltyConstants.CLEAR_SUCCESS_MESSAGE,
    payload: {},
  };
};

export { addMembers, getReferenceList, clearSuccessMessageLoyalty };
